module.exports = __webpack_public_path__ + "img/logo-header.9538e364.png";